import React from "react";
import { useTranslation } from "react-i18next";
import levelsProgressStarIcon from "../../assets/svg/levels-progress-star.svg";
import { classNames, constraint } from "../../helpers";
import ShowIf from "../show-if/ShowIf";

type ProgressBarProps = {
  numberOfLevels: number;
  finishedLevels?: number;
};
interface LevelProgressCardProps extends ProgressBarProps {
  levelTitle: string;
}
export default function LevelProgressCard(props: LevelProgressCardProps) {
  let { numberOfLevels, finishedLevels = 0, levelTitle } = props;
  finishedLevels = constraint(finishedLevels, 0, numberOfLevels);
  const isLevelInProgress =
    finishedLevels > 0 && finishedLevels < numberOfLevels;
  const isLevelCompleted = finishedLevels === numberOfLevels;
  const isLevelNotStarted = finishedLevels === 0;

  return (
    <div className="flex flex-row gap-3 items-center p-6 bg-white">
      <div className="flex flex-col flex-shrink-0 items-center">
        <ShowIf condition={isLevelInProgress}>
          <img
            src={levelsProgressStarIcon}
            className="w-9 h-9 md:w-12 md:h-12"
          />
        </ShowIf>
        <h3
          className={classNames(
            "text-sm md:text-base leading-6 font-medium",
            isLevelNotStarted ? "text-gray-400" : "text-gray-800"
          )}
        >
          {levelTitle}
        </h3>
      </div>
      <div className="flex flex-col gap-3 w-full">
        <ShowIf condition={isLevelInProgress}>
          <LevelHeader {...props} />
        </ShowIf>
        <ProgressBar {...props} />
      </div>
    </div>
  );
}

const Lesson = ({ passed = false }) => {
  return (
    <div
      className={`w-full h-3 rounded ${
        passed ? "bg-green-500" : "bg-gray-200"
      }`}
    ></div>
  );
};

const ProgressBar = (props: ProgressBarProps) => {
  const { numberOfLevels, finishedLevels = 0 } = props;
  const lessons = [...Array(numberOfLevels)].map((_, index) => {
    return <Lesson passed={index < finishedLevels} />;
  });
  return (
    <div className="flex flex-row gap-1">{React.Children.toArray(lessons)}</div>
  );
};

const LevelHeader = (props: ProgressBarProps) => {
  const { numberOfLevels, finishedLevels = 0 } = props;
  const { t, i18n } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.levelProgress",
  });
  const remainingLevels =
    ((numberOfLevels - finishedLevels) / numberOfLevels) * 100;
  return (
    <div className="flex flex-row gap-3 justify-between">
      <p className="text-sm md:text-base leading-6 font-medium text-gray-700">
        {t("remaining", { number: remainingLevels.toFixed(0) })}
      </p>
      <div className="flex flex-row font-medium">
        <div className=" text-gray-400 flex items-end">
          <span className="text-base leading-[21px]">{numberOfLevels}</span>
        </div>
        <div className="text-xl leading-6">{`${
          i18n.dir() === "rtl" ? "/" : "\\"
        }${finishedLevels}`}</div>
      </div>
    </div>
  );
};
